import { scales } from "plotly.js/src/components/colorscale";
import chroma from "chroma-js";
const edgeColorScale = (colorScale) => {
  const stops = scales[colorScale];
  const domains = stops.map(([domain]) => domain);
  const colors = stops.map(([, color]) => color);
  return chroma.scale(colors).domain(domains);
};
export default edgeColorScale;
